import React from 'react';
import { Card, Typography } from 'antd';

const SummaryCard = ({ icon, title, value, color = '#1890ff' }) => {
  return (
    <Card>
      <div className="flex-vertical-gap-3">
        <div className="flex-horizontal-gap-1">
          <div>{icon}</div>
          <Typography.Title level={2} style={{ margin: 0 }}>{title}</Typography.Title>
        </div>
        <div>{value}</div>
      </div>
    </Card>
  );
};

export default SummaryCard;
